import apiService from './api';
import type { AxiosInstance } from 'axios';
import { createRedemptionService } from '@shared/createRedemptionService';

/** MailBox apiService returns parsed JSON; shared factory expects axios `{ data }` shape. */
const mailboxRedemptionApi = {
  get: <T,>(url: string, config?: Parameters<AxiosInstance['get']>[1]) =>
    apiService.get<T>(url, config).then((data) => ({ data })),
  post: <T,>(url: string, body?: unknown, config?: Parameters<AxiosInstance['post']>[2]) =>
    apiService.post<T>(url, body, config).then((data) => ({ data })),
} satisfies Pick<AxiosInstance, 'get' | 'post'>;

const redemptionService = createRedemptionService(mailboxRedemptionApi);

export type {
  RedemptionBalanceBreakdown,
  RedemptionVerification,
  RedemptionStatus,
  RedemptionTeamAliasSummary,
  DisbursementHistoryItem,
  DisbursementResult,
  RedemptionConnectStatus,
  RedemptionConnectOnboardResult,
  RedemptionConnectSimulateResult,
} from '@shared/createRedemptionService';

export default redemptionService;
